import React from 'react';
import {
    Box, Chip,
    Divider, IconButton, Link,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead, TablePagination, TableRow, Tooltip,
    Typography
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {API_URL} from "../../../constants";
import {makeRequest} from "../../../services/requestService";
import {useState} from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {Link as RouterLink} from "react-router-dom";

const ITEMS_PER_PAGE = 10;

async function fetchCollections(page) {
    const url = `${API_URL}/collections?page=${page}&size=${ITEMS_PER_PAGE}`;
    const response = await makeRequest(url);
    return response.status === 200 ?
        {collections: response.data.data, totalItems: response.data.totalItems} :
        {collections: [], totalItems: 0};
}

export default function Collections(props) {
    const {t} = useTranslation("common");
    const [collections, setCollections] = useState([]);
    const [page, setPage] = useState(0);
    const [totalItems, setTotalItems] = useState(0);

    React.useEffect(async () => {
        const {collections, totalItems} = await fetchCollections(page);
        setCollections(collections);
        setTotalItems(totalItems);
    }, [page]);


    function handleChangePage(page) {
        setPage(page);
    }

    return (
        <Stack spacing={2}>
            <Typography variant="h6" fontSize={22} fontWeight="bold" color="textSecondary">
                {t('main.pages.admin.collections.title')}
            </Typography>
            <Divider/>
            <Box display="flex" justifyContent="flex-end">
                Search?
            </Box>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell>{t('main.pages.admin.collections.table.name')}</TableCell>
                            <TableCell>{t('main.pages.admin.collections.table.description')}</TableCell>
                            <TableCell>{t('main.pages.admin.collections.table.visibility')}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {collections.map(collection => (
                            <TableRow key={collection.id}>
                                <TableCell>{collection.id}</TableCell>
                                <TableCell>{collection.name}</TableCell>
                                <TableCell>{collection.description}</TableCell>
                                <TableCell>
                                    <Chip
                                        label={t(`main.components.form.collection.visibility.${collection.visibility.toLowerCase()}`)}/>
                                </TableCell>
                                <TableCell>
                                    <IconButton component={RouterLink} to={`/admin/collections/${collection.id}`}>
                                        <EditIcon color="primary"/>
                                    </IconButton>
                                    <Tooltip title="la suppression n'est pas encore possible" arrow>
                                        <IconButton disable>
                                            <DeleteIcon color="error"/>
                                        </IconButton>
                                    </Tooltip>
                               </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    size="small"
                    rowsPerPageOptions={[ITEMS_PER_PAGE]}
                    component="div"
                    count={totalItems}
                    rowsPerPage={ITEMS_PER_PAGE}
                    page={page}
                    onPageChange={(_, page) => handleChangePage(page)}
                />
            </TableContainer>
        </Stack>
    )
}